import React from "react";

export const ConnectIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9835 3.00497C11.5368 2.45176 11.5368 1.55483 10.9835 1.00162C10.4303 0.448409 9.5334 0.448409 8.98019 1.00162C8.42698 1.55483 8.42698 2.45176 8.98019 3.00497C9.5334 3.55818 10.4303 3.55818 10.9835 3.00497Z"
        fill="#833177"
      />
      <path
        d="M3.00503 11.0088C3.55824 10.4555 3.55824 9.55861 3.00503 9.0054C2.45182 8.45219 1.55489 8.45219 1.00168 9.0054C0.448466 9.55861 0.448466 10.4555 1.00168 11.0088C1.55489 11.562 2.45182 11.562 3.00503 11.0088Z"
        fill="#833177"
      />
      <path
        d="M18.9992 11.0088C19.5524 10.4555 19.5524 9.55861 18.9992 9.0054C18.446 8.45219 17.549 8.45219 16.9958 9.0054C16.4426 9.55861 16.4426 10.4555 16.9958 11.0088C17.549 11.562 18.446 11.562 18.9992 11.0088Z"
        fill="#833177"
      />
      <path
        d="M10.9777 18.9984C11.5309 18.4452 11.5309 17.5482 10.9777 16.995C10.4245 16.4418 9.52754 16.4418 8.97433 16.995C8.42112 17.5482 8.42112 18.4452 8.97433 18.9984C9.52754 19.5516 10.4245 19.5516 10.9777 18.9984Z"
        fill="#833177"
      />
      <path
        d="M9.97599 0.999718L10.4778 1.49958L18.9813 9.99132L9.97697 18.9956L3.4876 12.5063L4.48927 11.5046L9.97697 16.9923L16.9779 9.99132L9.97697 3.00209L4.4834 8.49566L3.48173 7.49398L9.97599 0.999718Z"
        fill="#833177"
      />
      <path
        d="M10.0006 4.98062L14.5189 9.49305L15.0207 9.99291L10.0006 15.013L6.9887 12.0012L7.99038 10.9995L10.0006 13.0097L13.0164 9.99389L10.0006 6.98397L7.99038 8.99417L6.9887 7.9925L10.0006 4.98062Z"
        fill="#833177"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99609 9.99353L10.0074 8.98218L11.0195 9.99281L10.0074 11.0049L8.99609 9.99353Z"
        fill="#833177"
      />
    </svg>
  );
};
